import { FormControl, Select, MenuItem, Box, Avatar, Typography, CircularProgress } from '@mui/material';
import { useServiceAdvisors } from '../api/useServiceAdvisors';
import { useTranslation } from 'react-i18next';

interface ServiceAdvisorSelectProps {
  value: string;
  onChange: (advisorId: string) => void;
  placeholder?: string;
  size?: 'small' | 'medium';
  variant?: 'outlined' | 'standard' | 'filled';
  disabled?: boolean;
  fullWidth?: boolean;
  sx?: Record<string, unknown>;
}

export const ServiceAdvisorSelect = ({
  value,
  onChange,
  placeholder,
  size = 'small',
  variant = 'outlined',
  disabled = false,
  fullWidth = false,
  sx = {},
}: ServiceAdvisorSelectProps) => {
  const { t } = useTranslation();
  const { data: advisors, isLoading } = useServiceAdvisors();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 1 }}>
        <CircularProgress size={16} />
      </Box>
    );
  }

  return (
    <FormControl variant={variant} size={size} fullWidth={fullWidth} disabled={disabled}>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        sx={{ backgroundColor: 'background.paper', ...sx }}
      >
        <MenuItem value="">
          <em>{placeholder ?? t('repairOrders.noServiceAdvisorAssigned')}</em>
        </MenuItem>
        {advisors.map((advisor) => (
          <MenuItem key={advisor.id} value={advisor.id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar
                src={advisor.avatarUrl ?? undefined}
                sx={{ bgcolor: 'primary.main', width: 24, height: 24, fontSize: '0.75rem' }}
              >
                {advisor.initials}
              </Avatar>
              <Typography variant="inherit">{advisor.displayName}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
